


































import Vue from 'vue';
import { saasCompanies } from '../constants';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';

export default Vue.extend({
  name: 'MainPageCompanies',
  components: { BravadoButtonV3 },
  data() {
    return {
      saasCompanies,
    };
  },
  methods: {
    emitSignUpClick() {
      this.$emit('sign-up-click', 'position6');
    },
  },
});
